import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import { calculateDiscountedPrice } from '@/components/StripeCheckout/utils/calculateDiscount';
import { getCheckoutParentPlans } from '@/lib/parent-plan-catalog';

const checkoutParentPlans = getCheckoutParentPlans();

const StripePlanButtons = ({ selectedPlan, setSelectedPlan, discountObject = null }) => {
    console.log('🚀 ~ StripePlanButtons ~ selectedPlan:', selectedPlan);
    const [originalSelectedPlan, setOriginalSelectedPlan] = useState(selectedPlan);

    const plans = useMemo(() => {
        return checkoutParentPlans?.map((plan, index) => {
            const classes = cx(
                'select-none cursor-pointer text-left shadow-teacher-intro-mobile max-w-[350px] pb-5 pt-7',
                'basis-full w-full p-[4px]   flex-col justify-center items-start gap-2 inline-flex',
                'rounded-[22px]',
                'p-1'
            );

            if (originalSelectedPlan !== index) return null;

            // Calculate discounted price if discount is applied
            const displayAmount = discountObject && discountObject.discount
                ? calculateDiscountedPrice(discountObject.discount, plan.amount)
                : plan.amount;

            return (
                <div tabIndex={index + 1} key={plan.id} onClick={(event) => setSelectedPlan && setSelectedPlan(event, index, plan)} className={classes}>
                    <div
                        className='w-full py-3 sm:py-0 p-1 sm:p-2 flex items-center md:items-start flex-col gap-1.5  sm:h-full relative'
                    >
                        <div className='text-center w-full '>
                            <div className='font-normal font-Poppins leading-7 text-[#231D4F]'>
                                <div className='font-semibold text-[24px]'>{plan.name}</div>
                                <div className='font-semibold text-[24px] mt-1'>FREE 7-day Trial</div>
                                <div className='text-lg mt-0.5 lowercase'>
                                    then {displayAmount}{index !== 0 && `/${plan.duration}`}
                                </div>
                                <div className='text-base mt-6'>{plan.monthly_cost_copy}</div>
                            </div>
                        </div>

                        {index === 2 && (
                            <div className='absolute w-full rounded-[30px] top-[-80px] right-[0%] z-[0] '>
                                <div className='mx-auto w-full flex justify-center mt-10'>
                                    <div className='bg-[#5F42CD]  w-[170px]  h-[30px] text-center  rounded-[30px] text-sm lg:text-base text-[#fff] font-semibold flex justify-center items-center'>
                                        Best Value!
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    }, [originalSelectedPlan, setSelectedPlan, discountObject]);
    console.log('plan elements:', plans);
    return (
        <div>
            <div className='PlanList relative flex flex-row-reverse justify-center w-full gap-4 sm:px-2 mt-5 sm:mt-0'>{plans}</div>
        </div>
    );
};

export default StripePlanButtons;
